import { CoachAvatar } from '@features/coaches/coachCard/coachAvatar/ui.tsx';
import { getFullNameM } from '@shared/helpers';
import type { RecommendationT } from '@shared/types/programs';
import * as st from './styles.module.scss';

type PT = {
  currentActiveRecommendation?: RecommendationT;
};

export const Comment = ({ currentActiveRecommendation }: PT) => {
  const coach = currentActiveRecommendation?.coach;
  return currentActiveRecommendation ? (
    <div className={st.comment}>
      <CoachAvatar size="large" photo={coach?.photo} />
      <p className={st.coachName}>
        {getFullNameM(coach?.first_name, coach?.middle_name, coach?.last_name)}
      </p>
    </div>
  ) : (
    'Нет individual в объекте программы'
  );
};
